// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoOverlay_container__bIDGy {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  
  .VideoOverlay_loadingContainer__FmT\\+D {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1a1a1a;
  }
  
  .VideoOverlay_heroSection__X30g0 {
    position: relative;
    width: 100%;
    height: 100vh;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: background-image 1s ease;
  }
  
  .VideoOverlay_overlay__2Cp0g {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
    linear-gradient(
      to top,
      rgba(26, 26, 26, 0.6) 0%,
      rgba(26, 26, 26, 0) 50%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4) 55%,
      rgba(0, 0, 0, 0) 80%,
      #1a1a1a 100%
    );
    z-index: 1;
  }
  
  .VideoOverlay_content__W1ZYP {
    position: relative;
    z-index: 2;
    padding: 0 5%;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 15vh;
  }
  
  .VideoOverlay_title__osIg6 {
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 1.5rem;
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    line-height: 1.1;
    animation: VideoOverlay_fadeInUp__tx9JV 0.8s ease;
  }
  
  .VideoOverlay_description__mU4KH {
    font-size: 1.4rem;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 2rem;
    line-height: 1.5;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
    animation: VideoOverlay_fadeInUp__tx9JV 0.8s ease 0.2s both;
  }
  
  .VideoOverlay_metaInfo__RDSz6 {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    gap: 1.5rem;
    animation: VideoOverlay_fadeInUp__tx9JV 0.8s ease 0.4s both;
  }
  
  .VideoOverlay_duration__g8eGy, .VideoOverlay_category__pXnd8 {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    font-size: 1.1rem;
    font-weight: 500;
  }
  
  .VideoOverlay_category__pXnd8 span {
    padding: 0.3rem 1rem;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
    font-size: 0.9rem;
  }
  
  .VideoOverlay_playButton__lkRJa {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    background-color: #e50914;
    color: white;
    border: none;
    padding: 0.9rem 2.5rem;
    border-radius: 4px;
    font-size: 1.3rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    width: fit-content;
    animation: VideoOverlay_fadeInUp__tx9JV 0.8s ease 0.6s both;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
  
  .VideoOverlay_playButton__lkRJa:hover {
    background-color: #f40612;
    transform: scale(1.05);
  }
  
  .VideoOverlay_autoplayContainer__gzdcO {
    position: absolute;
    bottom: 13vh;
    right: 5%;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }
  
  .VideoOverlay_indicatorsWrapper__vd6mQ {
    display: flex;
    gap: 0.5rem;
  }
  
  .VideoOverlay_indicator__2UlS- {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    overflow: hidden;
    position: relative;
  }
  
  .VideoOverlay_activeIndicator__WjoMs {
    background-color: rgba(255, 255, 255, 0.7);
  }
  
  .VideoOverlay_progress__hNQGS {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #e50914;
    transform-origin: left;
    animation: VideoOverlay_progressAnimation__oegW5 8s linear;
  }
  
  .VideoOverlay_autoplayToggle__HeNDY {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .VideoOverlay_autoplayToggle__HeNDY:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .VideoOverlay_previewContainer__kfmAj {
    position: relative;
    z-index: 2;
    padding: 0 5%;
    width: 100%;
    margin-bottom: 3vh;
  }
  
  .VideoOverlay_thumbnailWrapper__ebflE {
    display: flex;
    gap: 0.8rem;
    justify-content: center;
  }
  
  .VideoOverlay_thumbnailItem__YrwZ3 {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    flex: 0 0 auto;
    width: 200px;
    height: 112px;
    transition: all 0.3s ease;
    opacity: 0.7;
    transform: scale(0.95);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  
  .VideoOverlay_thumbnailItem__YrwZ3:hover {
    transform: scale(1);
    opacity: 0.9;
  }
  
  .VideoOverlay_activeItem__uufpb {
    transform: scale(1.1);
    opacity: 1;
    border: 2px solid #e50914;
    box-shadow: 0 6px 16px rgba(229, 9, 20, 0.4);
  }
  
  .VideoOverlay_thumbnailImage__Bq1Ir {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .VideoOverlay_thumbnailTitle__AX8UX {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    color: white;
    padding: 10px 8px;
    font-size: 0.8rem;
    text-align: center;
    font-weight: 500;
  }
  
  .VideoOverlay_progressBar__Nn67Y {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: rgba(255, 255, 255, 0.3);
  }
  
  .VideoOverlay_activeProgress__85zq\\+ {
    height: 100%;
    width: 0;
    background-color: #e50914;
    animation: VideoOverlay_progressAnimation__oegW5 8s linear forwards;
  }
  
  @keyframes VideoOverlay_progressAnimation__oegW5 {
    from { width: 0; }
    to { width: 100%; }
  }
  
  @keyframes VideoOverlay_fadeInUp__tx9JV {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Media queries for responsive design */
  @media screen and (max-width: 1200px) {
    .VideoOverlay_content__W1ZYP {
      width: 60%;
    }
    
    .VideoOverlay_title__osIg6 {
      font-size: 3rem;
    }
  }
  
  @media screen and (max-width: 992px) {
    .VideoOverlay_content__W1ZYP {
      width: 70%;
    }
    
    .VideoOverlay_thumbnailItem__YrwZ3 {
      width: 180px;
      height: 101px;
    }
  }
  
  @media screen and (max-width: 768px) {
    .VideoOverlay_heroSection__X30g0 {
      height: 70vh;
      background-image: none !important;
    }
    
    .VideoOverlay_heroSection__X30g0::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      z-index: 0;
      /* Mobile image displayed on smaller screens */
      background-image: var(--mobile-bg-image);
    }
    
    .VideoOverlay_content__W1ZYP {
      width: 90%;
      margin-bottom: 12vh;
    }
    
    .VideoOverlay_title__osIg6 {
      font-size: 2.5rem;
    }
    
    .VideoOverlay_description__mU4KH {
      font-size: 1.2rem;
    }
    
    .VideoOverlay_autoplayContainer__gzdcO {
      right: unset;
      left: 5%;
      bottom: 9vh;
    }
    
    .VideoOverlay_thumbnailItem__YrwZ3 {
      width: 150px;
      height: 84px;
    }
  }
  
  @media screen and (max-width: 576px) {
    .VideoOverlay_heroSection__X30g0 {
      height: 80vh;
    }
    
    .VideoOverlay_title__osIg6 {
      font-size: 18px;
    }
    
    .VideoOverlay_description__mU4KH {
      font-size: 1rem;
      margin-bottom: 1.5rem;
    }
    
    .VideoOverlay_metaInfo__RDSz6 {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      margin-bottom: 1.5rem;
    }
    
    .VideoOverlay_playButton__lkRJa {
      padding: 0.2rem 0.5rem;
      font-size: 12px;
      gap: 0.4rem;
    }
    
    .VideoOverlay_thumbnailTitle__AX8UX{
        padding: 5px;
        font-size: 8px;
    }
    .VideoOverlay_thumbnailWrapper__ebflE {
      gap: 0.5rem;
    }
    
    .VideoOverlay_thumbnailItem__YrwZ3 {
      width: 100px;
      height: 56px;
    }
    
    .VideoOverlay_autoplayContainer__gzdcO {
      bottom: 7vh;
    }
    
    .VideoOverlay_indicatorsWrapper__vd6mQ {
      gap: 0.3rem;
    }
    
    .VideoOverlay_indicator__2UlS- {
      width: 8px;
      height: 8px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/VideoOverlay.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;;;;;;;;;KAWC;IACD,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,2CAA2C;IAC3C,gBAAgB;IAChB,iDAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,2DAAuC;EACzC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,2DAAuC;EACzC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,0CAA0C;IAC1C,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,2DAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,0DAAsC;EACxC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,4DAA4D;IAC5D,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,yBAAyB;IACzB,mEAA+C;EACjD;;EAEA;IACE,OAAO,QAAQ,EAAE;IACjB,KAAK,WAAW,EAAE;EACpB;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,wCAAwC;EACxC;IACE;MACE,UAAU;IACZ;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,aAAa;IACf;EACF;;EAEA;IACE;MACE,YAAY;MACZ,iCAAiC;IACnC;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,sBAAsB;MACtB,2BAA2B;MAC3B,UAAU;MACV,8CAA8C;MAC9C,wCAAwC;IAC1C;;IAEA;MACE,UAAU;MACV,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;MACZ,QAAQ;MACR,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,YAAY;IACd;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;MACX,qBAAqB;IACvB;;IAEA;MACE,sBAAsB;MACtB,eAAe;MACf,WAAW;IACb;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;IACA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,UAAU;MACV,WAAW;IACb;EACF","sourcesContent":[".container {\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .loadingContainer {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #1a1a1a;\n  }\n  \n  .heroSection {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    background-size: cover;\n    background-position: center top;\n    background-repeat: no-repeat;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    transition: background-image 1s ease;\n  }\n  \n  .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: \n    linear-gradient(\n      to top,\n      rgba(26, 26, 26, 0.6) 0%,\n      rgba(26, 26, 26, 0) 50%\n    ),\n    linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.4) 55%,\n      rgba(0, 0, 0, 0) 80%,\n      #1a1a1a 100%\n    );\n    z-index: 1;\n  }\n  \n  .content {\n    position: relative;\n    z-index: 2;\n    padding: 0 5%;\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    margin-bottom: 15vh;\n  }\n  \n  .title {\n    font-size: 3.5rem;\n    font-weight: 800;\n    margin-bottom: 1.5rem;\n    color: white;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    line-height: 1.1;\n    animation: fadeInUp 0.8s ease;\n  }\n  \n  .description {\n    font-size: 1.4rem;\n    color: rgba(255, 255, 255, 0.9);\n    margin-bottom: 2rem;\n    line-height: 1.5;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);\n    animation: fadeInUp 0.8s ease 0.2s both;\n  }\n  \n  .metaInfo {\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n    gap: 1.5rem;\n    animation: fadeInUp 0.8s ease 0.4s both;\n  }\n  \n  .duration, .category {\n    display: flex;\n    align-items: center;\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 1.1rem;\n    font-weight: 500;\n  }\n  \n  .category span {\n    padding: 0.3rem 1rem;\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.05rem;\n    font-size: 0.9rem;\n  }\n  \n  .playButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.8rem;\n    background-color: #e50914;\n    color: white;\n    border: none;\n    padding: 0.9rem 2.5rem;\n    border-radius: 4px;\n    font-size: 1.3rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    width: fit-content;\n    animation: fadeInUp 0.8s ease 0.6s both;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  }\n  \n  .playButton:hover {\n    background-color: #f40612;\n    transform: scale(1.05);\n  }\n  \n  .autoplayContainer {\n    position: absolute;\n    bottom: 13vh;\n    right: 5%;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n  }\n  \n  .indicatorsWrapper {\n    display: flex;\n    gap: 0.5rem;\n  }\n  \n  .indicator {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.3);\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .activeIndicator {\n    background-color: rgba(255, 255, 255, 0.7);\n  }\n  \n  .progress {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #e50914;\n    transform-origin: left;\n    animation: progressAnimation 8s linear;\n  }\n  \n  .autoplayToggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .autoplayToggle:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n  }\n  \n  .previewContainer {\n    position: relative;\n    z-index: 2;\n    padding: 0 5%;\n    width: 100%;\n    margin-bottom: 3vh;\n  }\n  \n  .thumbnailWrapper {\n    display: flex;\n    gap: 0.8rem;\n    justify-content: center;\n  }\n  \n  .thumbnailItem {\n    position: relative;\n    border-radius: 4px;\n    overflow: hidden;\n    cursor: pointer;\n    flex: 0 0 auto;\n    width: 200px;\n    height: 112px;\n    transition: all 0.3s ease;\n    opacity: 0.7;\n    transform: scale(0.95);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n  \n  .thumbnailItem:hover {\n    transform: scale(1);\n    opacity: 0.9;\n  }\n  \n  .activeItem {\n    transform: scale(1.1);\n    opacity: 1;\n    border: 2px solid #e50914;\n    box-shadow: 0 6px 16px rgba(229, 9, 20, 0.4);\n  }\n  \n  .thumbnailImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .thumbnailTitle {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));\n    color: white;\n    padding: 10px 8px;\n    font-size: 0.8rem;\n    text-align: center;\n    font-weight: 500;\n  }\n  \n  .progressBar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: rgba(255, 255, 255, 0.3);\n  }\n  \n  .activeProgress {\n    height: 100%;\n    width: 0;\n    background-color: #e50914;\n    animation: progressAnimation 8s linear forwards;\n  }\n  \n  @keyframes progressAnimation {\n    from { width: 0; }\n    to { width: 100%; }\n  }\n  \n  @keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* Media queries for responsive design */\n  @media screen and (max-width: 1200px) {\n    .content {\n      width: 60%;\n    }\n    \n    .title {\n      font-size: 3rem;\n    }\n  }\n  \n  @media screen and (max-width: 992px) {\n    .content {\n      width: 70%;\n    }\n    \n    .thumbnailItem {\n      width: 180px;\n      height: 101px;\n    }\n  }\n  \n  @media screen and (max-width: 768px) {\n    .heroSection {\n      height: 70vh;\n      background-image: none !important;\n    }\n    \n    .heroSection::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-size: cover;\n      background-position: center;\n      z-index: 0;\n      /* Mobile image displayed on smaller screens */\n      background-image: var(--mobile-bg-image);\n    }\n    \n    .content {\n      width: 90%;\n      margin-bottom: 12vh;\n    }\n    \n    .title {\n      font-size: 2.5rem;\n    }\n    \n    .description {\n      font-size: 1.2rem;\n    }\n    \n    .autoplayContainer {\n      right: unset;\n      left: 5%;\n      bottom: 9vh;\n    }\n    \n    .thumbnailItem {\n      width: 150px;\n      height: 84px;\n    }\n  }\n  \n  @media screen and (max-width: 576px) {\n    .heroSection {\n      height: 80vh;\n    }\n    \n    .title {\n      font-size: 18px;\n    }\n    \n    .description {\n      font-size: 1rem;\n      margin-bottom: 1.5rem;\n    }\n    \n    .metaInfo {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n      margin-bottom: 1.5rem;\n    }\n    \n    .playButton {\n      padding: 0.2rem 0.5rem;\n      font-size: 12px;\n      gap: 0.4rem;\n    }\n    \n    .thumbnailTitle{\n        padding: 5px;\n        font-size: 8px;\n    }\n    .thumbnailWrapper {\n      gap: 0.5rem;\n    }\n    \n    .thumbnailItem {\n      width: 100px;\n      height: 56px;\n    }\n    \n    .autoplayContainer {\n      bottom: 7vh;\n    }\n    \n    .indicatorsWrapper {\n      gap: 0.3rem;\n    }\n    \n    .indicator {\n      width: 8px;\n      height: 8px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VideoOverlay_container__bIDGy`,
	"loadingContainer": `VideoOverlay_loadingContainer__FmT+D`,
	"heroSection": `VideoOverlay_heroSection__X30g0`,
	"overlay": `VideoOverlay_overlay__2Cp0g`,
	"content": `VideoOverlay_content__W1ZYP`,
	"title": `VideoOverlay_title__osIg6`,
	"fadeInUp": `VideoOverlay_fadeInUp__tx9JV`,
	"description": `VideoOverlay_description__mU4KH`,
	"metaInfo": `VideoOverlay_metaInfo__RDSz6`,
	"duration": `VideoOverlay_duration__g8eGy`,
	"category": `VideoOverlay_category__pXnd8`,
	"playButton": `VideoOverlay_playButton__lkRJa`,
	"autoplayContainer": `VideoOverlay_autoplayContainer__gzdcO`,
	"indicatorsWrapper": `VideoOverlay_indicatorsWrapper__vd6mQ`,
	"indicator": `VideoOverlay_indicator__2UlS-`,
	"activeIndicator": `VideoOverlay_activeIndicator__WjoMs`,
	"progress": `VideoOverlay_progress__hNQGS`,
	"progressAnimation": `VideoOverlay_progressAnimation__oegW5`,
	"autoplayToggle": `VideoOverlay_autoplayToggle__HeNDY`,
	"previewContainer": `VideoOverlay_previewContainer__kfmAj`,
	"thumbnailWrapper": `VideoOverlay_thumbnailWrapper__ebflE`,
	"thumbnailItem": `VideoOverlay_thumbnailItem__YrwZ3`,
	"activeItem": `VideoOverlay_activeItem__uufpb`,
	"thumbnailImage": `VideoOverlay_thumbnailImage__Bq1Ir`,
	"thumbnailTitle": `VideoOverlay_thumbnailTitle__AX8UX`,
	"progressBar": `VideoOverlay_progressBar__Nn67Y`,
	"activeProgress": `VideoOverlay_activeProgress__85zq+`
};
export default ___CSS_LOADER_EXPORT___;
